import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'space-between',
      gap: '25px',
      padding: '16px 5px',
    },
    column: {
      display: 'flex',
      alignItems: 'start',
      gap: '25px',
    },
    rootRadio: {
      padding: 0,
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
    },
    title: {
      fontWeight: 700,
      fontSize: '16px',
    },
    subTitle: {
      fontSize: '12px',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    button: {
      textDecoration: 'underline',
      color: '#2979ff',

      '&:hover': {
        backgroundColor: 'rgba(41, 121, 255, 0.1)',
      }
    }
  }
))
